import React from 'react'
import { Row, Col, Table, Button } from 'react-bootstrap'
import { Organization } from 'interfaces/organization'
import { User } from 'interfaces/user'
import OrganizationTableRow from './organization-table-row'

interface OrganizationTableProps {
  organizations: Organization[]
  internalAdmins: User[]
  selectedAssignments: Record<
    string,
    { account_manager_user_id?: string; sale_rep_id?: string }
  >
  handleAssignmentChange: (
    orgId: string,
    field: 'account_manager_user_id' | 'sale_rep_id',
    value: string
  ) => void
  getSelectedId: (
    orgId: string,
    field: 'account_manager_user_id' | 'sale_rep_id',
    fallback: string | number | null | undefined
  ) => string
  isValidId: (id: unknown) => boolean
  getEntityType: (url: string) => string
  sortOrder: 'asc' | 'desc'
  setSortOrder: (order: 'asc' | 'desc') => void
  onSaveSuccess: () => void
  isUpdatedPage?: boolean
}

const OrganizationTable: React.FC<OrganizationTableProps> = ({
  organizations,
  internalAdmins,
  selectedAssignments,
  handleAssignmentChange,
  getSelectedId,
  isValidId,
  getEntityType,
  sortOrder,
  setSortOrder,
  onSaveSuccess,
  isUpdatedPage = false,
}) => {
  return (
    <Row>
      <Col>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: '200px' }}>Organization Name</th>
              <th style={{ width: '80px' }}>Org ID</th>
              <th style={{ width: '80px' }}>Seats</th>
              <th style={{ width: '80px' }}>Amount</th>
              <th>Stripe Link</th>
              <th>HubSpot Deal</th>
              <th>Account Manager</th>
              <th>Sales Rep</th>
              <th
                style={{
                  width: '120px',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc')
                }
                title="Click to sort by date"
              >
                <div className="d-flex align-items-center justify-content-between">
                  <span>Date</span>
                  <span
                    style={{
                      fontSize: '14px',
                      color: sortOrder === 'desc' ? '#3498db' : '#95a5a6',
                      fontWeight: 'bold',
                    }}
                  >
                    {sortOrder === 'desc' ? '↓' : '↑'}
                  </span>
                </div>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {organizations.map((org) => (
              <OrganizationTableRow
                key={org.id}
                org={org}
                internalAdmins={internalAdmins}
                selectedAssignments={selectedAssignments}
                handleAssignmentChange={handleAssignmentChange}
                getSelectedId={getSelectedId}
                isValidId={isValidId}
                getEntityType={getEntityType}
                isUpdatedPage={isUpdatedPage}
              />
            ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

export default OrganizationTable
